import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import Group from '../../../Icons/Group';
import "./GroupShow.linaria.module.css!=!./GroupShow?./GroupShow.linaria.module.css?css=H4sIAAAAAAAAA22Q3U7DMAxG73kKLuEi0zpaCuFhovw4aYbrREnarkS8O5q0ohVxeWyfT7YPsoyiR+Hn1WBfdcCQ+CzTE2NK6k+XwkSGJZghZXj++H44XAWrRbOqljD+wXqecvF2ZTpQASo8R6mBKSgLAG36IJrhNZynrz1Vid4R8wXGzDVQgbQZOgtlyQW7p2oDFbaAd0Ph3fG4jb9n0ZTL4mesxueIcuUW4XKX9kYvzUntaZemApptvkehbNd6c/uPS3fH9Ci6rKeAt2aCX6/pYupMK9ahPSr7T+kxR0l1lMl5Ygi28FO8bvkDoSHwk5YBAAA="
const groupShowRootStyles = "atm_7l_ivydl7 atm_fc_1yb4nlp atm_h_1h6ojuz atm_cs_bfngof atm_9s_1txwivl";
const liveStyles = "atm_cs_8n312b atm_7l_bf54id";
const pendingStyles = "atm_cs_8n312b atm_7l_5scuol";
const iconContainerStyles = "atm_h_1h6ojuz atm_9s_1txwivl atm_15pr5d4_yh40bf";
interface GroupShowBannerProps {
  className?: LinariaClassName;
  style?: CSSProperties;
  roomCount: number;
  iconSize?: number;
  isLive: boolean;
}
const GroupShowBanner = memo((props: GroupShowBannerProps) => {
  const {
    className,
    iconSize,
    roomCount,
    isLive,
    style
  } = props;
  return <div data-testid="Container__GroupShowBanner" className={cx(groupShowRootStyles, className)} style={style}>
            <span data-testid="Label_ShowStatus">
                {'Show '}
                {isLive && <span className={liveStyles}>is live!</span>}
                {!isLive && <span className={pendingStyles}>pending.</span>}
            </span>
            <span className={iconContainerStyles}>
                <Group size={iconSize} />
                <span>{roomCount}</span>
            </span>
        </div>;
});
export default GroupShowBanner;
export { GroupShowBanner };